import { Component, ChangeDetectionStrategy } from "@angular/core";
import { LorenErrorTemplateComponent } from "../loren-error-template/loren-error-template.component";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "loren-service-unavailable",
    imports: [TranslocoPipe, LorenErrorTemplateComponent],
    templateUrl: "./loren-service-unavailable.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./loren-service-unavailable.component.scss"]
})
export class LorenServiceUnavailableComponent {}
